<template lang="pug">
.container.cadastroInformacao
  .card
    cadastro-sicarf(titleCadastro="Solicitar informação", routeName="informacoes", :cadastroEmpty="empty", :tabs="tabs")
</template>

<script>
import CadastroSicarf from '@/screens/central/components/CadastroSicarf'
import empty from '../empty/emptySolicitacaoInformacao'

export default {

  components: {
    CadastroSicarf
  },

  data () {
    return {
      // O atributo @name deve ser o mesmo da rota definida no router
      tabs: [
        {
          label: 'Cadastrante',
          name: 'informacoes/cadastrante',
          codigo: 'CADASTRANTE'
        },
        {
          label: 'Interessado',
          name: 'informacoes/interessado',
          codigo: 'INTERESSADO'
        },
        {
          label: 'Imóvel',
          name: 'informacoes/imovel',
          codigo: 'IMOVEL'
        },
        {
          label: 'Resumo',
          name: 'informacoes/resumo',
          isResumo: true
        }
      ],
      empty: empty
    }
  }

}
</script>

<style lang="scss" scoped>
.container {
  padding: 20px;
  .card {
    width: 100%;
  }
}

@media (max-width: 780px) {
  .container {
    padding: 20px 0;
  }

  .cadastroInformacao {
    top: 60px;
    width: 300px !important;
    position: relative;
    right: 125px;
  }

  .card {
    position: relative;
    left: 17px;
  }
}
</style>



// WEBPACK FOOTER //
// src/screens/central/cadastros/para/solicitarInformacao/Cadastro.vue